import UpdateGroupModal from "./UpdateGroupModal"

export default  UpdateGroupModal;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/GroupDetail/UpdateGroupModal/index.js